import Component from "@tunnel-components/@pages/login/component";
import * as React from "react";
import { connect } from "react-redux";
import {
  LoginActionCreator,
  UserAuthorizationLoadActionCreator,
} from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";
import { LoginContainerStates } from "@tunnel-models/index";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChangeValue
 * @name onSubmitValues
 * @name componentWillUnmount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<
  any,
  LoginContainerStates<any, boolean>
> {
  //  faire cette action toute les 50 millisecondes
  public debounceChange = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      formatLogin: false,
      loading: false,
      tokenexpired: false,
      tunnelWatchInfos: false,
      warning: false,
      submitSend: true,
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ [event.target.name]: event.target.value });
  }, 50);
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { boolean }      state.warning
     * @property { boolean }      state.error
     * @property { boolean }      state.loading
     * @property { boolean }      state.success
     * @property { boolean }      state.tunnelWatchInfos
     */
    this.state = {
      error: false,
      formatLogin: false,
      identifiant: "",
      loading: false,
      password: "",
      passwordType: true,
      success: false,
      tokenexpired: false,
      tunnelWatchInfos: false,
      warning: false,
      submitSend: true,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSubmitValues = this.onSubmitValues.bind(this);
    this.onChangePasswordType = this.onChangePasswordType.bind(this);
  }
  /**
   * manipulation des valeurs des inputs
   * @public
   * @method onChangeValue
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onChangeValue = (event: React.ChangeEvent<HTMLInputElement>): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */

    this.debounceChange(event);
  };
  /**
   * manipulation des valeurs des inputs
   * @public
   * @method onChangeValue
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onChangePasswordType = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      passwordType: !this.state.passwordType,
    }));
  };

  /**
   * Redirection après des inputs
   * @public
   * @method onSubmitValues
   * @param { any  }  event
   * @infos "https://reactjs.org"
   */
  public onSubmitValues = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      tokenexpired: false,
      loading: true,
      submitSend: false,
      warning: false,
    }));
    {
      /**  test du type ou existence du paramètre */
    }
    if (
      !Lodash.isEmpty(this.state.identifiant) &&
      !Lodash.isEmpty(this.state.password)
    ) {
      this.setState((state: any): any => ({ error: false, warning: false }));
      if (Utils.validatorString(this.state.identifiant, true)) {
        this.props.LoginActionCreator(this.state).then(() => {
          {
            /**  test du type ou existence du paramètre */
          }
          if (
            Lodash.isUndefined(this.props.login.error) &&
            Lodash.isUndefined(this.props.login.data)
          ) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              error: false,
              loading: false,
              success: false,
              tunnelWatchInfos: false,
              warning: false,
              submitSend: true,
            }));
          }
        });
      } else {
        this.setState((state: any): any => ({
          formatLogin: true,
          submitSend: true,
        }));
      }
      {
        /**  test du type ou existence du paramètre */
      }
    } else if (
      Lodash.isEmpty(this.state.identifiant) ||
      Lodash.isEmpty(this.state.password)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        formatLogin: false,
        loading: false,
        warning: true,
        submitSend: true,
      }));
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      formatLogin: false,
      loading: false,
      passwordType: true,
      tokenexpired: false,
      tunnelWatchInfos: false,
      warning: false,
      submitSend: true,
    }));

    // Stopper l'action une fois le component détruit
    this.debounceChange.cancel();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.login.data !== this.props.login.data) {
      if (!Lodash.isUndefined(nextProps.login.data)) {
        if (!Lodash.isNull(nextProps.login.data)) {
          if (Utils.verifIsTokenIsValidOrExpired()) {
            this.setState((state: any): any => ({
              error: false,
              tokenexpired: false,
              formatLogin: false,
              success: true,
              submitSend: true,
              warning: false,
              loading: false,
            }));

            this.props.UserAuthorizationLoadActionCreator();

            setTimeout(() => {
              this.props.history.push(Paths.PathsNamesEnums.TUNNELWATCH);
            }, 3000);
          } else {
            this.setState((state: any): any => ({
              tokenexpired: true,
              error: false,
              formatLogin: false,
              success: false,
              warning: false,
              loading: false,
              submitSend: true,
            }));
          }
        }
      }
    } else if (nextProps.login.error !== this.props.login.error) {
      if (!Lodash.isUndefined(nextProps.login.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          error: true,
          loading: false,
          success: false,
          tokenexpired: false,
          tunnelWatchInfos: false,
          warning: false,
          submitSend: true,
        }));
      }
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        onChangeValue={this.onChangeValue}
        onSubmitValues={this.onSubmitValues}
        onChangePasswordType={this.onChangePasswordType}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    login: state.Login,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  LoginActionCreator,
  UserAuthorizationLoadActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/login/container.tsx